"use strict";
// packages/types/src/compliance.ts
Object.defineProperty(exports, "__esModule", { value: true });
